import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import withStyles from '@material-ui/core/styles/withStyles'
import Rating from '@material-ui/lab/Rating'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: '#FFFFFF',
        padding: '1rem 1.5rem',
        position: 'relative',
        boxShadow: `0 0px 2px rgb(0 0 0 / 5%), 0 0px 5.5px rgb(0 0 0 / 7%), 0 0px 13.3px rgb(0 0 0 / 9%), 0 0px 44px rgb(0 0 0 / 14%)`,
        borderRadius: '5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        rowGap: '.5rem',
    },
    content: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        columnGap: '.5rem',
    },
    logo: {
        maxWidth: '60px !important',
        height: 'auto',
    },
    header: {
        fontSize: '1rem',
        margin: '0 0 .5rem 0',
        whiteSpace: 'nowrap',
    },
    reviewLink: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    ratingCount: {
        fontSize: '.75rem',
    },
    largeRating: {
        fontSize: '2rem',
    },
}))

const StyledRating = withStyles((theme) => ({
    iconFilled: {
        color: theme.palette.primary.main,
    },
}))(Rating)

const StoreReviewItem = ({ name, logo, ratingsCount, rating, url }) => {
    const classes = useStyles()
    return (
        <article className={classes.container}>
            <div className={classes.content}>
                <img
                    src={logo}
                    loading="lazy"
                    alt={`${name} Logo`}
                    className={classes.logo}
                    height="60"
                    width="60"
                />
                <div>
                    <h2 className={classes.header}>{name}</h2>
                    <div>
                        <Typography
                            component="legend"
                            className={classes.ratingCount}
                            data-testid="rating-legend"
                        >
                            {`~${ratingsCount} RATINGS`}
                        </Typography>
                        <StyledRating
                            name={`${name} rating`}
                            value={Number(rating)}
                            precision={0.1}
                            readOnly
                            size="small"
                        />
                    </div>
                </div>
                <div className={classes.largeRating}>
                    {Number(rating).toFixed(1)}
                </div>
            </div>
            <a
                href={url}
                target="_blank"
                rel="noopener nofollow"
                className={classes.reviewLink}
                title={`Go to ${name} reviews`}
            >
                Go To {name} Reviews &#8594;
            </a>
        </article>
    )
}

export default StoreReviewItem
